import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

declare global {
  interface Window {
    [key: string]: any;
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private isLoaded = false;
 private dataLayerName = 'dataLayer'; // default name

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  loadGTM(gtmId: string): void {
    if (!isPlatformBrowser(this.platformId) || this.isLoaded) return;

    const w = window;
    const d = document;
    const s = 'script';
    const l = this.dataLayerName;
    const i = gtmId;

    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.defer = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode?.insertBefore(j, f);

    this.isLoaded = true;
  }
}
